// extracted by mini-css-extract-plugin
export default {"wrapper":"cf","focus":"df","button":"ef","options":"ff","label":"gf"};